import React from 'react';
import EstadoCuentaListado from './EstadoCuentaListado.jsx';

// Réplica de `IbuFront/.../Admin/EstadoCuenta/EstadoCuenta.jsx` (ver EstadoCuentaListado.jsx).
// `GET /reportes/estado-cuenta/cliente/:id` trae {fecha, movimiento, concepto, cargo,
// comision, abono, numero}; el saldo corrido se calcula en el navegador igual que V1.
const CFG = {
  permiso: 'estado-cuenta:clientes',
  route: 'clientes',
  nombreKey: 'nombre_comercial',
  titulo: 'Estado de Cuenta',
  encabezadoNombre: 'Nombre Comercial',
  encabezadoAcciones: 'Estado Cuenta',
  entidad: 'Cliente',
  conComision: true,
  kardexPath: (id) => `/reportes/estado-cuenta/cliente/${id}`,
  relacionadoPath: (id) => `/reportes/estado-cuenta/cliente/${id}/relacionado`,
  tituloPdf: 'Estado de Cuenta',
  archivoPdf: 'EstadosDeCuenta',
  archivoExcel: 'EstadoCuenta',
  archivoModal: 'EdoCtaCliente',
  hojaModal: 'EstadoCuenta',
};

export default function EstadoCuentaClientePage() {
  return <EstadoCuentaListado cfg={CFG} />;
}
